import React from "react";
import { style } from "style";

const GoogleButton = ({ url }) => {
  //
  // onClick
  //
  const handle = () =>
    window.open(
      url,
      "_parent",
      "toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30",
    );

  return (
    <button style={styles.button} onClick={handle}>
      <img
        src="https://developers.google.com/identity/images/g-logo.png"
        alt="Google Logo"
        style={styles.image}
      />
      Entrar com Google
    </button>
  );
};

//
// Talves, cada cliente irá precisar de um pequeno ajuste de margem para corrigir
// alinhamento entre o logo(À esquerda) com o botão fo Google (à direita)
//
const getMargins = () => {
  // console.log(style.api.nameProfile)

  // Na tela de SSO na Solides, precisou de 30px no "top"
  //
  if (style.api.nameProfile === "Solidianos") {
    return "30px 0px 0px 0px";
  }

  // Todos os demais continuam no default
  return "0px";
};

const styles = {
  button: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "white",
    border: `1px solid ${style.colors.primaryColor}`,
    borderRadius: "5px",
    padding: "10px 70px",
    margin: getMargins(),
    cursor: "pointer",
    fontFamily: "Arial, sans-serif",
    fontSize: "16px",
    fontWeight: "bold",
    color: style.colors.primaryColor,
    gap: "10px",
    textTransform: "uppercase",
  },
  image: {
    width: "20px",
    height: "20px",
  },
};

export default GoogleButton;
